import { render, staticRenderFns } from "./apply-info.vue?vue&type=template&id=972aeb14&scoped=true&"
import script from "./apply-info.vue?vue&type=script&lang=js&"
export * from "./apply-info.vue?vue&type=script&lang=js&"
import style0 from "./apply-info.vue?vue&type=style&index=0&id=972aeb14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972aeb14",
  null
  
)

export default component.exports